var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "desktop-path",
    width: 1019,
    height: 928,
    viewBox: "0 0 1019 928",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273 1L289.885 21.6896C323.675 63.0942 375.985 84.782 429.159 79.4321V79.4321C480.113 74.3057 531.257 87.1409 573.752 115.719L593.5 129",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M907 376.5L966.766 443.203C995.682 475.476 993.165 525.028 961.128 554.205V554.205C927.05 585.24 880.358 598.435 835.078 589.826L633.5 551.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230 547L84.5134 604.622C34.4078 624.466 1.5 672.895 1.5 726.787V726.787C1.5 811.14 79.8508 873.644 162.095 854.901L202.022 845.802C237.037 837.822 273.704 841.551 306.396 856.418L460.5 926.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPath);
export default __webpack_public_path__ + "static/media/DesktopPath.ec570796795263c5efdf705defff4478.svg";
export { ForwardRef as ReactComponent };